module.exports = __webpack_public_path__ + "img/Persepsi-Audio0.a10dd228.png";